/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ShareNetworkIcon24Regular = forwardRef('ShareNetworkIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.05 6a3.75 3.75 0 1 1 .925 2.466L9.58 10.885a3.749 3.749 0 0 1 0 2.23l4.394 2.419a3.75 3.75 0 1 1-.741 1.304l-4.377-2.41a3.75 3.75 0 1 1 0-4.858l4.377-2.408A3.747 3.747 0 0 1 13.05 6Zm3.75-2.25a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5ZM6 9.75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5ZM14.55 18a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0Z" })));
});
